import React from 'react';
import './next-steps-card.scss';

interface TimelineItemProps {
    title: string;
    isActive?: boolean;
    isPast?: boolean;
}

const TimelineItem: React.FC<TimelineItemProps> = ({ title, isActive, isPast }) => (
    <div className={`timeline-item ${isActive ? 'timeline-item--active' : ''} ${isPast ? 'timeline-item--past' : ''}`}>
        <div className="timeline-item__bullet timeline-item__bullet" ></div>
        <div className="timeline-item__body">
            <div className="timeline-item__content">
                <div className="timeline-item__text">{title}</div>
            </div>
        </div>
    </div>
);

const NextSteps: React.FC = () => {
    return (
        <div className="timeline-container">
            <div className="timeline-card" data-with-border="true">
                <h1 className="timeline-title">Next steps:</h1>
                <div className="timeline">
                    <TimelineItem title="Mental health assessment" isActive={true} />
                    <TimelineItem title="Book appointment" />
                </div>
            </div>
        </div>
    );
};

export default NextSteps;
